import { useQuery } from 'react-query';

import { axios } from 'lib/axios';

export const NOTIFICATIONS_REFRESH_INTERVAL = 60 * 1000;

export const getNotifications = ({ page, limit }) => {
  return axios.get('/api/notifications', { params: { offset: page * limit, limit } });
};

export const useNotifications = ({ page = 0, limit = 10, queryOptions = {} } = {}) => {
  return useQuery(['notifications', 'list', { page, limit }], () => getNotifications({ page, limit }), {
    select: ({ data }) => ({ notifications: data.data ?? [], total: data.total ?? 0 }),
    keepPreviousData: true,
    useErrorBoundary: false,
    refetchInterval: NOTIFICATIONS_REFRESH_INTERVAL,
    ...queryOptions,
  });
};
